<template>
  <div>
    <div class="b-banner-con">
      <v-header></v-header>
      <v-nav></v-nav>
    </div>
    <v-breadcrumb></v-breadcrumb>
    <div class="b-center-container">
      <div class="b-container">
        <div class="b-center-main">
          <div class="b-richtext">
            <p v-html="richText2"></p>
          </div>
        </div>
      </div>
    </div>
    <v-contact></v-contact>
  </div>
</template>
<script>
/* eslint-disable */
import Header from "@/components/header/en/";
import Nav from "@/components/nav/en/";
import Copy from "@/components/copy/"
import Breadcrumb from "@/components/breadcrumb/en/"
import Contact from "@/components/contact/en/";
export default {
  data () {
    return {
      richText2: '',
    };
  },
  mounted () {
    this.richText2 = '<p style="text-align: left; "><span style="font-size: 22px; border-bottom: solid 3px #033d80;">Biotherapy Development Core</span></p>'
      + '<p>&nbsp;</p>'

      + '<div id="left" style="float:left ; width:75%; height:100%;">'
      + '<p style="margin-bottom : 20px; margin-right : 20px;text-align: justify"><span style="font-size: 16px">Biotherapy Development Core mainly includes cell therapy, gene therapy and immunotherapy. It possesses a GMP laboratory that accords with the requirements of clinical treatment standards, and is provided with facilities and equipments such as bioreactor, biosafety cabinet, blood cell separator and cell sorter. The platform\n' +
      'will provide safe and qualified biotherapy products for clinical trials, and promote the clinical transformation of scientific achievements.</span></p>'
      + '</div>'

      + '<div id="right" style="float:left ; width:25%; height:100%;">'
      + '<p style="margin-left : 40px"><img src="https://nbcloud-repairorder-image.oss-cn-beijing.aliyuncs.com/wangyueyin.jpg" style="float: left; width: 200px; margin-right: 30px; margin-top:20px;" border="0" vspace="0" alt=""></p>'
      + '<p style="margin-left:50px;text-align: justify"><span style="font-size: 16px;"><b>Director: Yueying Wang</b></span></p>'
      + '</div>'
      + '<p>&nbsp;</p>'

      + '<div>'
      + '<p><span style="font-size: 16px;border:10px solid #033d80; background-color: #033d80; border-radius: 7px; color: white;"> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;GMP Lab&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></p>'
      + '<p style="margin-top : 30px;margin-bottom : 30px; margin-right : 20px;text-align: justify"><span style="font-size: 16px">According to international and domestic professional standards, we have established a super clean GMP labora- tory that accords with the requirements of clinical treatment standards. It provides infrastructure for the clinical transformation of biotherapy research projects.</span></p>'

      + '<p><span style="font-size: 16px;border:10px solid #033d80; background-color: #033d80; border-radius: 7px;color: white; "> &nbsp;&nbsp;&nbsp;Management System of GMP Core &nbsp;&nbsp;&nbsp;</span></p>'
      + '<p style="margin-top : 30px;margin-bottom : 30px; margin-right : 20px;text-align: justify"><span style="font-size: 16px">According to the requirements of GMP production quality management standard, a strict and standardized management system should be established. There is a clear division of labor, process and record for each link in the production process, as well as strict examination and approval links, in which any change can be traced back to the source, with evidences to check and evidences to rely on.</span></p>'

      + '<p><span style="font-size: 16px;border:10px solid #033d80; background-color: #033d80; border-radius: 7px; color: white;"> Promoting Clinical Transformation Research </span></p>'
      + '<p style="margin-top : 30px;margin-bottom : 30px; margin-right : 20px;text-align: justify"><span style="font-size: 16px">Based on the development of potential biotherapy products, as well as the validation of clinical efficacy and safety by preclinical trials, we will optimize and expand the production process of biotherapy products, and produce safe and qualified products by using our GMP platform, thus providing reliable technical services for the development of high-level clinical transformation research.</span></p>'
      + '<p style="text-align: center;"><img src="https://nbcloud-repairorder-image.oss-cn-beijing.aliyuncs.com/biotherapy_development_core_1_en.jpg" style="float: left; width: 800px; " border="0" vspace="0" ></p>'

      + '<p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p>'
      + '<p style="text-align: left; "><span style="font-size: 16px; border-bottom: solid 3px #033d80;">Contact</span></p>'
      + '<p style="text-align: left; "><span style="font-size: 16px; ">Shuxian Yao</span></p>'
      + '<p style="text-align: left; "><span style="font-size: 16px; ">Email: yaoshuxianxian@163.com</span></p>'

      + '</div>'

      + '<p>&nbsp;</p><p>&nbsp;</p>'
},
  components: {
    "v-header": Header,
    "v-nav": Nav,
    "v-copy": Copy,
    "v-breadcrumb": Breadcrumb,
    "v-contact": Contact,
  }
};
</script>
<style lang="scss">
  @media screen and (max-width:600px) {
	.b-banner-con{
	    //padding: 22px 0;
	    background: url(../../../assets/img/banner_bg.png) no-repeat!important;
	    background-size: cover!important;
	    .b-header{
	      margin-bottom: 0px;
	    }
	    height: 134px;
	    width: 1440px;
	}
  }

  @media screen and (min-width:960px) {
    .b-banner-con{
	    //padding: 22px 0;
	    background: url(../../../assets/img/banner_bg.png) no-repeat!important;
	    background-size: cover!important;
	    .b-header{
	      margin-bottom: 0px;
	    }
	    height: 134px;
    }
  }
.b-richtext {
  text-align:left;
  b,
  strong {
    font-weight: 700;
  }
  p {
    margin: 0 0 10px;
    line-height: 24px;
  }
  line-height: 24px;
}
</style>



// WEBPACK FOOTER //
// src/pages/Service7/en/index.vue